// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"516":"77cf1b08","812":"155e5dcb","912":"7515e4bd","915":"393ea382"}[chunkId] + ".chunk.js";
};